import React, { FunctionComponent } from 'react';

import './voiceover.scss';
import { useStore } from '../../../helpers/use-store';
import { useVideoContext } from '../../../hooks/use-video';
import { LoadingState, useLoading } from '@monorepo/react-components';
import { VoiceoverList } from '../../../components/voiceover-list/voiceover-list';
import { useNotification } from '../../../hooks/use-notification';
import { Languages } from '@monorepo/types';
import { useTranslation } from 'react-i18next';

interface Props {
  voiceoverId: string;
}

const VideoVoiceover: FunctionComponent<Props> = ({ voiceoverId }) => {
  const { t } = useTranslation();
  const {
    dataStore: { voiceoverStore, userStore },
  } = useStore();
  const { updateVoiceover, video } = useVideoContext();
  const { updateLoadingState, loadingState } = useLoading();
  const notificationApi = useNotification();

  const handleVoiceoverUpdate = async (selectedVoiceId: string) => {
    try {
      updateLoadingState(LoadingState.Loading);
      await updateVoiceover({ voiceoverId: selectedVoiceId });

      userStore.getLatestUser();

      notificationApi.success({
        placement: 'top',
        message: t('common.success'),
        description: t('videoEditor.voiceover.updateSuccess'),
      });
    } catch (e) {
      notificationApi.error({
        placement: 'top',
        icon: '',
        message: t('common.error'),
        description: t('videoEditor.voiceover.updateError'),
      });

      console.error('failed updating voiceover', e);
    } finally {
      updateLoadingState(LoadingState.Loaded);
    }
  };

  return (
    <VoiceoverList
      language={(video?.language as Languages) || Languages.English}
      voiceoverId={voiceoverId}
      voiceovers={voiceoverStore.items}
      onButtonClick={handleVoiceoverUpdate}
      showUpdateButton
      updateButtonText={t('videoEditor.voiceover.updateButton')}
      updateDescription={t('videoEditor.voiceover.updateDescription')}
      loading={loadingState === LoadingState.Loading}
    />
  );
};

export default VideoVoiceover;
